module.exports = __webpack_public_path__ + "static/media/la-solid-900.0f874d69.svg";